/**
 * Assignment effective-window helpers (client mirror of
 * server/api-util/assignmentSync.js → assignmentEffectiveState).
 *
 * Accepting an assignment flips its status to 'active', but the assignment
 * only takes effect — Gig Boost, audience/insights access, countdown —
 * inside its [startDate, endDate] window:
 *   - status !== 'active' → 'inactive' (pending/rejected/revoked/expired)
 *   - now < startDate     → 'scheduled' (accepted, not started yet)
 *   - now > endDate       → 'expired'
 *   - otherwise           → 'effective'
 * A missing startDate ⇒ effective immediately on accept; a missing endDate
 * ⇒ no expiry by date. Keep this in sync with the server helper so the UI
 * and the access gates agree.
 */
export const assignmentEffectiveState = (assignment, now = new Date()) => {
  if (!assignment || assignment.status !== 'active') return 'inactive';
  const t = (now instanceof Date ? now : new Date(now)).getTime();
  if (assignment.startDate) {
    const start = new Date(assignment.startDate).getTime();
    if (Number.isFinite(start) && t < start) return 'scheduled';
  }
  if (assignment.endDate) {
    const end = new Date(assignment.endDate).getTime();
    if (Number.isFinite(end) && t > end) return 'expired';
  }
  return 'effective';
};

// An accepted assignment whose start date is still in the future.
export const isAssignmentScheduled = (assignment, now) =>
  assignmentEffectiveState(assignment, now) === 'scheduled';

// An accepted assignment that is in effect right now.
export const isAssignmentEffective = (assignment, now) =>
  assignmentEffectiveState(assignment, now) === 'effective';
